export type Service = {
  title: string;
  description: string;
};

export const services: Service[] = [
  {
    title: "Product Strategy",
    description:
      "Discovery, research, and roadmaps that translate your vision into a confident launch plan.",
  },
  {
    title: "Design Systems",
    description:
      "Unified UI kits and interaction patterns so every screen feels cohesive and premium.",
  },
  {
    title: "Web & Mobile Engineering",
    description:
      "High-performance apps built with modern stacks, ready to scale with your business.",
  },
  {
    title: "Cloud & Integrations",
    description:
      "Secure APIs, automation, and cloud-native infrastructure that keep you future-ready.",
  },
];
